import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext(null);

const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  const isAdmin = currentUser?.roles?.includes('admin') ?? false;

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser, isAdmin }}>
      {children}
    </UserContext.Provider>
  );
};

const useCurrentUser = () => useContext(UserContext);

export { UserProvider, useCurrentUser };
